import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { FormValidationMessage } from 'ui';
import useInputTimeRange from './useInputTimeRange';

// Constante de módulo y no `[new Date(), new Date()]` en la firma: el hook se resincroniza cuando `value`
// cambia de identidad, y un array nuevo en cada render borraría el error en cada pintado.
const DEFAULT_VALUE = [new Date(), new Date()];

function noop() {}

const InputTimeRange = ({ endTimeLabel, error = false, label, minTime, name = 'timerange', onChange = noop, startTimeLabel, t, value = DEFAULT_VALUE }) => {
  const {
    endInputId,
    endTime,
    endTimeName,
    groupLabelId,
    groupRole,
    handleChangeEnd,
    handleChangeStart,
    hasLabel,
    inputDescribedBy,
    isInvalid,
    labelId,
    startInputId,
    startTime,
    startTimeName,
    validationId,
    validationMessage,
  } = useInputTimeRange({ endTimeLabel, error, label, minTime, name, onChange, startTimeLabel, t, value });

  return (
    <Fragment>
      {hasLabel && (
        <span className="input-time-range__label" id={labelId}>
          {label}
        </span>
      )}
      <div aria-labelledby={groupLabelId} className={`input-time-range ${error ? 'input-time-range--error' : ''}`} role={groupRole}>
        <label className="sr-only" htmlFor={startInputId}>
          {startTimeName}
        </label>
        <input
          aria-describedby={inputDescribedBy}
          aria-invalid={isInvalid}
          className="input-time-range__input"
          id={startInputId}
          onChange={handleChangeStart}
          required
          type="time"
          value={startTime}
        />
        <div className="input-time-range__separator-container">
          <div className="input-time-range__separator"></div>
        </div>
        <label className="sr-only" htmlFor={endInputId}>
          {endTimeName}
        </label>
        <input
          aria-describedby={inputDescribedBy}
          aria-invalid={isInvalid}
          className="input-time-range__input"
          id={endInputId}
          onChange={handleChangeEnd}
          required
          type="time"
          value={endTime}
        />
      </div>
      {validationMessage && <FormValidationMessage id={validationId} text={validationMessage} type="error" />}
    </Fragment>
  );
};

InputTimeRange.propTypes = {
  endTimeLabel: PropTypes.string,
  error: PropTypes.bool,
  label: PropTypes.node,
  minTime: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  startTimeLabel: PropTypes.string,
  t: PropTypes.func.isRequired,
  value: PropTypes.array,
};

export default withTranslation(['new-course', 'placeholder'])(InputTimeRange);
